var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopyIcon = function SvgCopyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.51,
    height: 17.564,
    viewBox: "0 0 14.51 17.564",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M3.919,1.527H9.555a1,1,0,0,1,1,1V6.109h1.527V2.528A2.528,2.528,0,0,0,9.555,0H3.919A2.528,2.528,0,0,0,1.391,2.528V8.591a2.49,2.49,0,0,0,2.451,2.528V9.591a.962.962,0,0,1-.924-1V2.528a1,1,0,0,1,1-1Zm9.53,5.346H7.661A2.451,2.451,0,0,0,5.21,9.324v5.788a2.451,2.451,0,0,0,2.451,2.451H13.45A2.451,2.451,0,0,0,15.9,15.113V9.324A2.451,2.451,0,0,0,13.45,6.873Zm.924,8.24a.924.924,0,0,1-.924.924H7.661a.924.924,0,0,1-.924-.924V9.324A.924.924,0,0,1,7.661,8.4H13.45a.924.924,0,0,1,.924.924Z",
    transform: "translate(-1.391)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy-icon.d9fc8f6a.svg";
export { ForwardRef as ReactComponent };